import { options } from '../constants/newrelic';
import { Company } from '../models/company.model';

export const enableNewrelicMonitoring = (company: Company) => {
  try {
    if (
      company?.isMonitoring &&
      company.isMonitoring === true &&
      typeof window !== 'undefined'
    ) {
      const loadBa = async () => {
        const { BrowserAgent } = await import(
          '@newrelic/browser-agent/loaders/browser-agent'
        );
        const { JSErrors } = await import(
          '@newrelic/browser-agent/features/jserrors'
        );
        Object.assign(options, {
          init: {
            features: [JSErrors],
            ...options.init
          }
        });
        console.log({ options });
        return new BrowserAgent(options);
      };
      loadBa().then((ba) => {
        console.log('start client monitoring.');
        // クライアントエラーの送信
        window.onerror = (event, message, lineno, colno, error) => {
          console.log({ event, message, lineno, colno, error });
          console.log({ error });
          console.log('start');
          if (error) {
            console.log('send');
            ba.noticeError(error);
          }
          console.log('finish');
        };
      });
    }
  } catch (e) {
    // 既存処理に影響でないようにエラーを握りつぶす
    console.error({ e });
  }
};
